import culture from "./culture";
/*
 * contains function to parse and format numeric values
 */
//*** all following parts are extracted out of jquery-ui library (GPL/MIT license) ***/
var _helper = {
    _defaults: { shortYearCutoff: "+10", dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"] },
    _ticksTo1970: (((1970 - 1) * 365 + Math.floor(1970 / 4) - Math.floor(1970 / 100) + Math.floor(1970 / 400)) * 24 * 60 * 60 * 10000000),
    _daylightSavingAdjust: function (date) {
        if (!date) {
            return null;
        }
        date.setHours(date.getHours() > 12 ? date.getHours() + 2 : 0);
        return date;
    },
    _getDaysInMonth: function (year, month) {
        return 32 - _helper._daylightSavingAdjust(new Date(year, month, 32)).getDate();
    }
};
var date = /** @class */ (function () {
    function date() {
    }
    /* Parse a string value into a date object.
See formatDate below for the possible formats.

@param  format    string - the expected format of the date
@param  value     string - the date in the above format
@param  settings  Object - attributes include:
shortYearCutoff  number - the cutoff year for determining the century (optional)
dayNamesShort    string[7] - abbreviated names of the days from Sunday (optional)
dayNames         string[7] - names of the days from Sunday (optional)
monthNamesShort  string[12] - abbreviated names of the months (optional)
monthNames       string[12] - names of the months (optional)
@return  Date - the extracted date value or null if value is blank */
    date.parse = function (value, format, settings) {
        if (value === null) {
            return null;
        }
        if (value === undefined) {
            return undefined;
        }
        if (value == "") {
            return null;
        }
        format = format || culture.info.dateFormat;
        //value = (typeof value == 'object' ? value.toString() : value + '');
        var shortYearCutoff = (settings ? settings.shortYearCutoff : null) || _helper._defaults.shortYearCutoff;
        shortYearCutoff = (typeof shortYearCutoff != "string" ? shortYearCutoff :
            new Date().getFullYear() % 100 + parseInt(shortYearCutoff, 10));
        var dayNamesShort = (settings ? settings.dayNamesShort : null) || _helper._defaults.dayNamesShort;
        var dayNames = (settings ? settings.dayNames : null) || _helper._defaults.dayNames;
        var monthNamesShort = (settings ? settings.monthNamesShort : null) || _helper._defaults.monthNamesShort;
        var monthNames = (settings ? settings.monthNames : null) || _helper._defaults.monthNames;
        var year = -1;
        var month = -1;
        var day = -1;
        var doy = -1;
        var literal = false;
        // Check whether a format character is doubled
        var lookAhead = function (match) {
            var matches = (iFormat + 1 < format.length && format.charAt(iFormat + 1) == match);
            if (matches) {
                iFormat++;
            }
            return matches;
        };
        // Extract a number from the string value
        var getNumber = function (match) {
            var isDoubled = lookAhead(match);
            var size = (match == "@" ? 14 : (match == "!" ? 20 :
                (match == "y" && isDoubled ? 4 : (match == "o" ? 3 : 2))));
            var digits = new RegExp("^\\d{1," + size + "}");
            var num = value.substring(iValue).match(digits);
            if (!num) {
                throw "Missing number at position " + iValue;
            }
            iValue += num[0].length;
            return parseInt(num[0], 10);
        };
        // Extract a name from the string value and convert to an index
        var getName = function (match, shortNames, longNames) {
            var names = (lookAhead(match) ? longNames : shortNames);
            for (var i = 0; i < names.length; i++) {
                if (value.substr(iValue, names[i].length).toLowerCase() == names[i].toLowerCase()) {
                    iValue += names[i].length;
                    return i + 1;
                }
            }
            throw new Error("Unknown name at position " + iValue);
        };
        // Confirm that a literal character matches the string value
        var checkLiteral = function () {
            if (value.charAt(iValue) != format.charAt(iFormat)) {
                throw "Unexpected literal at position " + iValue;
            }
            iValue++;
        };
        var iValue = 0;
        for (var iFormat = 0; iFormat < format.length; iFormat++) {
            if (literal) {
                if (format.charAt(iFormat) == "'" && !lookAhead("'")) {
                    literal = false;
                }
                else {
                    checkLiteral();
                }
            }
            else {
                switch (format.charAt(iFormat)) {
                    case "d":
                        day = getNumber("d");
                        break;
                    case "D":
                        getName("D", dayNamesShort, dayNames);
                        break;
                    case "o":
                        doy = getNumber("o");
                        break;
                    case "m":
                        month = getNumber("m");
                        break;
                    case "M":
                        month = getName("M", monthNamesShort, monthNames);
                        break;
                    case "y":
                        year = getNumber("y");
                        break;
                    case "@":
                        var date = new Date(getNumber("@"));
                        year = date.getFullYear();
                        month = date.getMonth() + 1;
                        day = date.getDate();
                        break;
                    case "!":
                        var date = new Date((getNumber("!") - _helper._ticksTo1970) / 10000);
                        year = date.getFullYear();
                        month = date.getMonth() + 1;
                        day = date.getDate();
                        break;
                    case "'":
                        if (lookAhead("'")) {
                            checkLiteral();
                        }
                        else {
                            literal = true;
                        }
                        break;
                    default:
                        checkLiteral();
                }
            }
        }
        if (year == -1) {
            year = new Date().getFullYear();
        }
        else if (year < 100) {
            year += new Date().getFullYear() - new Date().getFullYear() % 100 +
                (year <= shortYearCutoff ? 0 : -100);
        }
        if (doy > -1) {
            month = 1;
            day = doy;
            do {
                var dim = _helper._getDaysInMonth(year, month - 1);
                if (day <= dim) {
                    break;
                }
                month++;
                day -= dim;
            } while (true);
        }
        var result = _helper._daylightSavingAdjust(new Date(year, month - 1, day));
        if (result.getFullYear() != year || result.getMonth() + 1 != month || result.getDate() != day) {
            throw new Error("Invalid date");
        } // E.g. 31/02/*
        return result;
    };
    /* Format a date object into a string value.
The format can be combinations of the following:
d  - day of month (no leading zero)
dd - day of month (two digit)
o  - day of year (no leading zeros)
oo - day of year (three digit)
D  - day name short
DD - day name long
m  - month of year (no leading zero)
mm - month of year (two digit)
M  - month name short
MM - month name long
y  - year (two digit)
yy - year (four digit)
@ - Unix timestamp (ms since 01/01/1970)
! - Windows ticks (100ns since 01/01/0001)
'...' - literal text
'' - single quote

@param  format    string - the desired format of the date
@param  date      Date - the date value to format
@param  settings  Object - attributes include:
dayNamesShort    string[7] - abbreviated names of the days from Sunday (optional)
dayNames         string[7] - names of the days from Sunday (optional)
monthNamesShort  string[12] - abbreviated names of the months (optional)
monthNames       string[12] - names of the months (optional)
@return  string - the date in the above format */
    date.format = function (date, format, settings) {
        if (!date || isNaN(date)) {
            return "";
        }
        format = format || culture.info.dateFormat;
        var dayNamesShort = (settings ? settings.dayNamesShort : null) || _helper._defaults.dayNamesShort;
        var dayNames = (settings ? settings.dayNames : null) || _helper._defaults.dayNames;
        var monthNamesShort = (settings ? settings.monthNamesShort : null) || _helper._defaults.monthNamesShort;
        var monthNames = (settings ? settings.monthNames : null) || _helper._defaults.monthNames;
        // Check whether a format character is doubled
        var lookAhead = function (match) {
            var matches = (iFormat + 1 < format.length && format.charAt(iFormat + 1) == match);
            if (matches) {
                iFormat++;
            }
            return matches;
        };
        // Format a number, with leading zero if necessary
        var formatNumber = function (match, value, len) {
            var num = "" + value;
            if (lookAhead(match)) {
                while (num.length < len) {
                    num = "0" + num;
                }
            }
            return num;
        };
        // Format a name, short or long as requested
        var formatName = function (match, value, shortNames, longNames) {
            return (lookAhead(match) ? longNames[value] : shortNames[value]);
        };
        var output = "";
        var literal = false;
        if (date) {
            for (var iFormat = 0; iFormat < format.length; iFormat++) {
                if (literal) {
                    if (format.charAt(iFormat) == "'" && !lookAhead("'")) {
                        literal = false;
                    }
                    else {
                        output += format.charAt(iFormat);
                    }
                }
                else {
                    switch (format.charAt(iFormat)) {
                        case "d":
                            output += formatNumber("d", date.getDate(), 2);
                            break;
                        case "D":
                            output += formatName("D", date.getDay(), dayNamesShort, dayNames);
                            break;
                        case "o":
                            output += formatNumber("o", (date.getTime() - new Date(date.getFullYear(), 0, 0).getTime()) / 86400000, 3);
                            break;
                        case "m":
                            output += formatNumber("m", date.getMonth() + 1, 2);
                            break;
                        case "M":
                            output += formatName("M", date.getMonth(), monthNamesShort, monthNames);
                            break;
                        case "y":
                            output += (lookAhead("y") ? date.getFullYear() :
                                (date.getFullYear() % 100 < 10 ? "0" : "") + date.getFullYear() % 100);
                            break;
                        case "@":
                            output += date.getTime();
                            break;
                        case "!":
                            output += date.getTime() * 10000 + _helper._ticksTo1970;
                            break;
                        case "'":
                            if (lookAhead("'")) {
                                output += "'";
                            }
                            else {
                                literal = true;
                            }
                            break;
                        default:
                            output += format.charAt(iFormat);
                    }
                }
            }
        }
        return output;
    };
    date.formatTime = function (value, inputMode) {
        if (inputMode === "HourMinute") {
            return value ? (pad(value.getHours()) + ":" + pad(value.getMinutes())) : "";
        }
        else if (inputMode === "HourMinuteSecond") {
            return value ? (pad(value.getHours()) + ":" + pad(value.getMinutes()) + ":" + pad(value.getSeconds())) : "";
        }
        return "";
    };
    date.now = function () {
        return new Date();
    };
    date.addSeconds = function (d, seconds) {
        var future = new Date(d);
        future.setSeconds(d.getSeconds() + seconds);
        return future;
    };
    date.addMinutes = function (d, minutes) {
        var future = new Date(d);
        future.setMinutes(d.getMinutes() + minutes);
        return future;
    };
    date.addHours = function (d, hours) {
        var future = new Date(d);
        future.setHours(d.getHours() + hours);
        return future;
    };
    date.addDays = function (d, days) {
        var future = new Date(d);
        future.setDate(d.getDate() + days);
        return future;
    };
    date.getDaysBetween = function (startDate, endDate) {
        return Math.round((endDate - startDate) / (1000.0 * 3600.0 * 24.0));
    };
    date.getMsBetween = function (startDate, endDate) {
        return endDate.getTime() - startDate.getTime();
    };
    date.onlyDate = function (d) {
        if (d == null) {
            return d;
        }
        var result = new Date(d);
        result.setHours(0, 0, 0, 0);
        return result;
    };
    date.equal = function (date1, date2) {
        return (date1 && date1.getTime()) === (date2 && date2.getTime());
    };
    return date;
}());
export { date };
function pad(nr) {
    if (nr < 10) {
        return "0" + nr.toString();
    }
    else {
        return nr.toString();
    }
}
